import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Canal enxuto entre telas e a navbar: os "acessos rápidos" da Home pedem a
 * expansão de um grupo do menu (accordion) pelo LABEL exato da seção em
 * `_nav.ts`. O NavComponent escuta e abre o grupo com um destaque breve.
 */
@Injectable({ providedIn: 'root' })
export class NavigationUiService {

  private expandSection = new Subject<string>();
  readonly expandSection$ = this.expandSection.asObservable();

  requestExpandSection(sectionLabel: string): void {
    this.expandSection.next(sectionLabel);
  }
}
